import { UnitType } from '../enums/products';

export const DEFAULT_PRODUCT_MODIFIER_GROUP_NAME = 'MISCELLANEOUS';

export const VOLUME_UNITS = {
  ml: 'mL',
  l: 'L',
};
export const WEIGHT_UNITS = {
  kg: 'Kg',
  g: 'g',
};

export const PRODUCT_UNITS = {
  [UnitType.Volume]: [VOLUME_UNITS.ml, VOLUME_UNITS.l],
  [UnitType.Weight]: [WEIGHT_UNITS.kg, WEIGHT_UNITS.g],
};

export const DEFAULT_OPTION_GROUP = 'DEFAULT';
export const DEFAULT_MAX_LIMIT_FOR_ZERO_SELECTION = 999;

export const DEFAULT_PRODUCT_GROUP = 'Unassigned Product Group';
export const DEFAULT_CATEGORY = 'Uncategorized';
export const DEFAULT_REPORTING_GROUP = 'Missing Reporting Group';
